import request from "@/axios.js";
export class Backlinks {
	static getById(id){
			return new Promise((resolve, reject) =>{
					request.get("contract/get/" + id)
	
	
						.then(res => {
							//console.log(res);
							resolve(res.data);
						})
						.catch(err => {
							//console.log(err);
							reject(err);
						});
				} )
		}

	static getAllLists(){
		return new Promise((resolve, reject) => {
			request.get("backlinks/list")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	static getListsWithFullData(params = {}){
		return new Promise((resolve, reject) => {
			// GET /backlinks/lists/full with pagination params
			const queryParams = new URLSearchParams({
				page: params.page || 1,
				limit: params.limit || 20,
				...(params.society_id && { society_id: params.society_id })
			}).toString();
			
			request.get(`backlinks/lists/full?${queryParams}`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	static createList(data){
		return new Promise((resolve, reject) => {
			// POST /backlinks/list with { name, society_id }
			request.post("backlinks/list", {
				name: data.name,
				society_id: data.society_id
			})
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	static addBacklinksToList(listId, backlink_ids){
		return new Promise((resolve, reject) => {
			// POST /backlinks/list/items with { list_id, backlink_ids }
			request.post('backlinks/list/items', {
				list_id: listId,
				backlink_ids: backlink_ids
			})
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	static getListDetails(listId){
		return new Promise((resolve, reject) => {
			// GET /backlinks/list/:id/full - Get list details with all items
			request.get(`backlinks/list/${listId}/full`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	static deleteList(listId){
		return new Promise((resolve, reject) => {
			// DELETE /backlinks/list/:id - Delete a backlinks list
			request.delete(`backlinks/list/${listId}`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static getColumns(){
		return [
			{"title": "Site", "key": "name"},
			{"title": "Pays", "key": "hosting_country"},
			{"title": "Prix PaperClub", "key": "articles_price"},
			{"title": "Prix RocketLinks", "key": "articles_price_1"},
			{"title": "Trafic", "key": "traffic"},
			{"title": "TF", "key": "tf"},
			{"title": "CF", "key": "cf"},
			{"title": "Domain Ref", "key": "domain_ref"},
			{"title": "Mots-clés", "key": "keywords"},
			{"title": "Score", "key": "bqs_score"},
			{"title": "Thématique", "key": "category"}];
	}
	static getSubColumnsPaperClub(){
		return [

			{"title": "CODE", "key": "hosting_code"},
			{"title": "PRIX", "key": "articles_price"},
			{"title": "RD", "key": "domain_ref"},
			{"title": "BL", "key": "bl"},
			{"title": "TF", "key": "tf"},
			{"title": "CF", "key": "cf"},
			{"title": "MTTF", "key": "maxTopicalTrustFlow"},
			{"title": "AGE", "key": "domainAge"},
			{"title": "GOOGLENEWS", "key": "googleNews"},

		];
	}
	static getSubColumnsRocketLinks(){
		return [
			{"title": "CODE", "key": "hosting_code"},
			{"title": "PRIX", "key": "rock_price_redaction"},
			// {"title": "PRIX RECOMM", "key": "rock_price_recommande"},
			{"title": "RD", "key": "rock_domain_ref"},
			{"title": "BL", "key": "rock_bl"},
			{"title": "TF", "key": "rock_tf"},
			{"title": "CF", "key": "rock_cf"},
			{"title": "MTTF", "key": "rock_maxTopicalTrustFlow"},
			{"title": "AGE", "key": "rock_domainAge"},
			{"title": "GOOGLENEWS", "key": "rock_googleNews"},

		];
	}
	static getSortList(){
		return [
			{"label": "Relevant", "id": 0},
			{"label": "DA -", "id": 1},
			{"label": "DR -", "id": 2},
			{"label": "DA +", "id": 3},
			{"label": "DR +", "id": 4},
			// {"title": "PRIX RECOMM", "key": "rock_price_recommande"},

		];
	}

	static getFields(){
		return [{
			title: "Site",
			dataIndex: "name",
			key: "name",
			width: 120,
			fixed: "left",
			/*
			 * filters: [{
			 * 	text: "Joe",
			 * 	value: "Joe",
			 * }, {
			 * 	text: "John",
			 * 	value: "John",
			 * }],
			 * onFilter: (value, record) => record.name.indexOf(value) === 0,
			 */
		}, {
			title: "PaperClub",
			children: [

				/*
				 * {
				 * 	title: "Payes",
				 * 	dataIndex: "hosting_country",
				 * 	key: "hosting_country",
				 * 	width: 70,
				 * 	// sorter: (a, b) => a.hosting_country - b.hosting_country,
				 * },
				 */
				{
					title: "Code",
					dataIndex: "hosting_code",
					key: "hosting_code",
					width: 50,
					// sorter: (a, b) => a.hosting_code - b.hosting_code,
				},
				{
					title: "DR",
					dataIndex: "domainRating",
					key: "domainRating",
					width: 50,
					// sorter: (a, b) => a.domainRating - b.domainRating,
				},
				{
					title: "Trafic",
					dataIndex: "traffic",
					key: "traffic",
					width: 80,
					// sorter: (a, b) => a.traffic - b.traffic,
				},
				{
					title: "Mots-cle",
					dataIndex: "keywords",
					key: "keywords",
					width: 80,
					// sorter: (a, b) => a.keywords - b.keywords,
				},
				{
					title: "Prix",
					dataIndex: "articles_price",
					key: "articles_price",
					width: 50,
					// sorter: (a, b) => a.articles_price - b.articles_price,
				},
				{
					title: "RD",
					dataIndex: "domain_ref",
					key: "domain_ref",
					width: 50,
					// sorter: (a, b) => a.domain_ref - b.domain_ref,
				},
				{
					title: "BL",
					dataIndex: "bl",
					key: "bl",
					width: 70,
					// sorter: (a, b) => a.bl - b.bl,
				},
				{
					title: "TF",
					dataIndex: "tf",
					key: "tf",
					width: 50,
					// sorter: (a, b) => a.tf - b.tf,
				},
				{
					title: "CF",
					dataIndex: "cf",
					key: "cf",
					width: 50,
					// sorter: (a, b) => a.cf - b.cf,
				},
				{
					title: "Thématiques",
					dataIndex: "category",
					key: "category",
					width: 100,
					// sorter: (a, b) => a.category - b.category,
				},
				{
					title: "MTTF",
					dataIndex: "maxTopicalTrustFlow",
					key: "maxTopicalTrustFlow",
					width: 80,
					// sorter: (a, b) => a.maxTopicalTrustFlow - b.maxTopicalTrustFlow,
				},
				{
					title: "Age",
					dataIndex: "domainAge",
					key: "domainAge",
					width: 50,
					// sorter: (a, b) => a.domainAge - b.domainAge,
				},
				{
					title: "googleNews",
					dataIndex: "googleNews",
					key: "googleNews",
					width: 60,
					// sorter: (a, b) => a.googleNews - b.googleNews,
				},
				{
					title: "Lien ahrefs",
					dataIndex: "link_ahref",
					key: "link_ahref",
					width: 100,
					// sorter: (a, b) => a.category - b.category,
				},
				/*
				 * {
				 * 	title: "Statut",
				 * 	dataIndex: "status",
				 * 	key: "status",
				 * 	width: 80,
				 * 	// sorter: (a, b) => a.status - b.status,
				 * },
				 * {
				 * 	title: "AS",
				 * 	dataIndex: "articles_sponsored",
				 * 	key: "articles_sponsored",
				 * 	width: 50,
				 * 	// sorter: (a, b) => a.articles_sponsored - b.articles_sponsored,
				 * },
				 * {
				 * 	title: "Mots",
				 * 	dataIndex: "articles_words",
				 * 	key: "articles_words",
				 * 	width: 50,
				 * 	// sorter: (a, b) => a.articles_words - b.articles_words,
				 * },
				 */



				/*
				 * {
				 * 	title: "Ratio",
				 * 	dataIndex: "ratio",
				 * 	key: "ratio",
				 * 	width: 50,
				 * 	// sorter: (a, b) => a.ratio - b.ratio,
				 * },
				 */







				/*
				 * {
				 * 	title: "Nouveau",
				 * 	dataIndex: "neww",
				 * 	key: "neww",
				* 	width: 50,Backlinks
				 * 	// sorter: (a, b) => a.neww - b.neww,
				 * },
				 */
			],
		}, {
			title: "Rocket Links",
			children: [
				{
					title: "DA",
					dataIndex: "rock_da",
					key: "rock_da",
					width: 50,
					// sorter: (a, b) => a.da - b.da,
				},
				{
					title: "Trafic",
					dataIndex: "rock_traffic",
					key: "rock_traffic",
					width: 80,
					// sorter: (a, b) => a.traffic - b.traffic,
				},
				{
					title: "Mots-cle",
					dataIndex: "rock_keywords",
					key: "rock_keywords",
					width: 80,
					// sorter: (a, b) => a.keywords - b.keywords,
				},
				{
					title: "Prix Redac",
					dataIndex: "rock_price_redaction",
					key: "rock_price_redaction",
					width: 80,
					// sorter: (a, b) => a.price_redaction - b.price_redaction,
				},
				{
					title: "Prix Recomm",
					dataIndex: "rock_price_recommande",
					key: "rock_price_recommande",
					width: 100,
					// sorter: (a, b) => a.price_recommande - b.price_recommande,
				},
				{
					title: "Domain Ref",
					dataIndex: "rock_domain_ref",
					key: "rock_domain_ref",
					width: 80,
					// sorter: (a, b) => a.domain_ref - b.domain_ref,
				},
				{
					title: "BL",
					dataIndex: "rock_bl",
					key: "rock_bl",
					width: 70,
					// sorter: (a, b) => a.bl - b.bl,
				},
				{
					title: "TF",
					dataIndex: "rock_tf",
					key: "rock_tf",
					width: 50,
					// sorter: (a, b) => a.tf - b.tf,
				},
				{
					title: "CF",
					dataIndex: "rock_cf",
					key: "rock_cf",
					width: 50,
					// sorter: (a, b) => a.cf - b.cf,
				},





				/*
				 * {
				 * 	title: "Trafic SW",
				 * 	dataIndex: "rock_traffic_sw",
				 * 	key: "rock_traffic_sw",
				 * 	width: 50,
				 * 	// sorter: (a, b) => a.traffic_sw - b.traffic_sw,
				 * },
				 */
				{
					title: "THÉMATIQUES",
					dataIndex: "rock_category",
					key: "rock_category",
					width: 100,
					// sorter: (a, b) => a.category - b.category,
				},
				{
					title: "Lien ahrefs",
					dataIndex: "rock_link_ahref",
					key: "link_ahref",
					width: 100,
					// sorter: (a, b) => a.category - b.category,
				},
			],
		}];
	}

	compare(contactToCompare){
		for(let key in contactToCompare) {
			if(this[key] != contactToCompare[key]){
				return false;
			}
		}
		return true;
	}

	static getCategoryOption(){
		return [
			{
				id: 1,
				name: "Alimentation & Boissons"
			},
			{
				id: 2,
				name: "Animaux"
			},
			{
				id: 3,
				name: "Auto & Moto"
			},
			{
				id: 4,
				name: "BTP & Industrie"
			},
			{
				id: 5,
				name: "Business & Entreprise"
			},
			{
				id: 6,
				name: "Culture & Art"
			},
			{
				id: 7,
				name: "Ecologie & Environnement"
			},
			{
				id: 8,
				name: "Economie & Société"
			},
			{
				id: 9,
				name: "Famille & Enfant"
			},
			{
				id: 10,
				name: "Finance & Banque"
			},
			{
				id: 11,
				name: "Formation & Emploi"
			},
			{
				id: 12,
				name: "Gaming & Jeux vidéo"
			},
			{
				id: 13,
				name: "Généraliste"
			},
			{
				id: 14,
				name: "High-Tech & Geek"
			},
			{
				id: 15,
				name: "Immobilier & Assurance"
			},
			{
				id: 16,
				name: "Informatique"
			},
			{
				id: 17,
				name: "Jeux d'argent"
			},
			{
				id: 18,
				name: "Juridique & Droit"
			},
			{
				id: 19,
				name: "Lifestyle & Vie pratique"
			},
			{
				id: 20,
				name: "Loisirs & Divertissement"
			},
			{
				id: 21,
				name: "Maison & Jardin"
			},
			{
				id: 22,
				name: "Mariage"
			},
			{
				id: 23,
				name: "Marketing & Communication"
			},
			{
				id: 24,
				name: "Mode & Beauté"
			},
			{
				id: 25,
				name: "Religion"
			},
			{
				id: 26,
				name: "Rencontre"
			},
			{
				id: 27,
				name: "Santé & Bien-être"
			},
			{
				id: 28,
				name: "Sciences"
			},
			{
				id: 29,
				name: "Sexe & Adulte"
			},
			{
				id: 30,
				name: "Shopping & Promo"
			},
			{
				id: 31,
				name: "Sport"
			},
			{
				id: 32,
				name: "Tourisme & Voyage"
			},
			{
				id: 33,
				name: "Transport"
			},
			{
				id: 34,
				name: "Voyance & Esotérisme"
			},

		];
	}





	static getRocketlinkCategoryOption(){
		return [
			{
				id: 1,
				name: "Actualités - Médias généralistes"
			},
			{
				id: 2,
				name: "Adulte - Rencontre"
			},
			{
				id: 3,
				name: "Animaux"
			},
			{
				id: 4,
				name: "Annuaire (en cours)"
			},
			{
				id: 5,
				name: "Auto - Moto"
			},
			{
				id: 6,
				name: "B2B - Entrepreneurs - Marketing"
			},

		];
	}
}

